/** Lucide icons for dashboard nav tiles — keyed by `dashboardNav` item labels. */

import {
  UserCheck,
  Droplets,
  Cog,
  CalendarDays,
  BarChart2,
  LayoutGrid,
  Boxes,
  FlaskConical,
  Info,
  ListPlus,
  SlidersHorizontal,
  UserPlus,
  Users,
  ClipboardCheck,
  Settings2,
  Network,
  Wrench,
  Beaker,
  PackageCheck,
  SprayCan,
  Factory,
  Hourglass,
  Snowflake,
  UserCog,
  ClipboardList,
  type LucideIcon,
} from 'lucide-react'

/**
 * Must stay in lockstep with `dashboardNavGroups` item labels. A missing key
 * yields `undefined` and React crashes in CardBody with an opaque "element
 * type is invalid" error — `iconForDashboardNav` throws a clear message instead.
 */
export const dashboardNavIcons: Record<string, LucideIcon> = {
  Transplant: UserCheck,
  Collection: Droplets,
  Processing: Cog,
  Inventory: Boxes,
  'Pending Inventory': Hourglass,
  Storage: Snowflake,
  Kit: PackageCheck,
  Cleaning: SprayCan,
  MES: Factory,
  Release: FlaskConical,
  Products: Beaker,
  'Upcoming Procedure': CalendarDays,
  CAPA: ClipboardCheck,
  // The list-plus tile of the spec (z8nrz7fkfh).
  'Action Items': ListPlus,
  Notifications: Info,
  Resource: UserPlus,
  Reports: BarChart2,
  Dashboards: LayoutGrid,
  'Master Data': Network,
  'Form Builder': ListPlus,
  Configuration: Settings2,
  Users: UserCog,
  // Menu-only shortcut to Configure → Purchase Orders (z8nrz7f7dz); not a Home tile.
  'Purchase Orders': ClipboardList,
  Integration: SlidersHorizontal,
  Patients: Users,
  Equipment: Wrench,
}

export function iconForDashboardNav(label: string): LucideIcon {
  const Icon = dashboardNavIcons[label]
  if (!Icon) {
    throw new Error(
      `Missing dashboard nav icon for label "${label}". Update dashboardNavIcons.`,
    )
  }
  return Icon
}
